<template>
  <Teleport to="body">
    <div
        v-if="isVisible"
        class="modal-overlay d-flex align-items-center justify-content-center"
        @click.self="close"
    >
      <div class="modal-dialog custom-modal-content">
        <div class="modal-content border-0 shadow-lg">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title text-warning fw-bold">
              {{ title }} <span v-if="duration > 0" class="text-secondary fw-normal fs-6">({{ timeLeft }}s)</span>
            </h5>
            <button
                v-if="showCloseButton"
                type="button"
                class="btn-close btn-close-white"
                aria-label="Close"
                @click="close"
            ></button>
          </div>
          <div class="modal-body py-4">
            <p class="text-white mb-0">{{ message }}</p>
          </div>
              <div v-if="isConfirm" class="modal-footer border-0 pt-0 justify-content-end gap-2">
                <button
                    type="button"
                    class="btn btn-sm btn-outline-light"
                    @click="cancel"
                >
                  {{ cancelText }}
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-warning fw-bold"
                    @click="confirm"
                >
                  {{ confirmText }}
                </button>
              </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'FullPageAlert',
  emits: ['close', 'confirm', 'cancel'],
  props: {
    title: {
      type: String,
      default: 'Powiadomienie'
    },
    message: {
      type: String,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 5000
      },
      isConfirm: {
        type: Boolean,
        default: false
      },
      confirmText: {
        type: String,
        default: 'Potwierdź'
      },
      cancelText: {
        type: String,
        default: 'Anuluj'
    }
  },
  data() {
    return {
      isVisible: true,
      timer: null,
      countdownInterval: null,
      timeLeft: Math.ceil(this.duration / 1000)
    }
  },
  mounted() {
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        this.close();
      }, this.duration);

      this.countdownInterval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        }
      }, 1000);
    }
  },
  beforeUnmount() {
    if (this.timer) clearTimeout(this.timer);
    if (this.countdownInterval) clearInterval(this.countdownInterval);
  },
  methods: {
    close() {
      this.isVisible = false;
      this.$emit('close');
        },
        confirm() {
          this.isVisible = false;
          this.$emit('confirm');
        },
        cancel() {
          this.isVisible = false;
          this.$emit('cancel');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: transparent; /* Transparent background as requested */
  backdrop-filter: blur(4px); /* Subtle blur behind the modal */
  z-index: 2000;
}

.custom-modal-content {
  width: 100%;
  max-width: 450px;
  margin: 1.5rem;
}

.modal-content {
  background-color: rgba(30, 30, 45, 0.85); /* Slightly transparent background */
  backdrop-filter: blur(10px); /* Internal blur for modern glass look */
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px;
  padding: 0.5rem; /* Additional padding for the container */
}

.modal-header {
  padding: 1.25rem 1.25rem 0.5rem 1.25rem;
}

.modal-body {
  padding: 0.5rem 1.25rem 1.5rem 1.25rem;
}

.modal-title {
  letter-spacing: 0.05rem;
  font-size: 1.1rem;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
  opacity: 0.7;
}

.btn-close-white:hover {
  opacity: 1;
}
</style>